import { globalTheme, PRIMARY_COLOR } from '@frontend/shared/ui';
import type { ThemeConfig } from 'antd';

export const theme: ThemeConfig = {
  ...globalTheme,
  components: {
    ...globalTheme.components,
    Menu: {
      ...globalTheme.components.Menu,
      itemSelectedColor: PRIMARY_COLOR,
    },
  },
};
